var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgNewcsDashboardCrashanalysisIssuedetailTracedataOperateYesIcon = function SvgNewcsDashboardCrashanalysisIssuedetailTracedataOperateYesIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "newcs_dashboard_crashanalysis_issuedetail_tracedata_operate_yes_icon_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M843 911h14v14h-14z",
    "data-name": "\\u77E9\\u5F62 405"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#newcs_dashboard_crashanalysis_issuedetail_tracedata_operate_yes_icon_svg__a)",
    transform: "translate(-843 -911)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#429289",
    d: "M854.846 920.156a.544.544 0 0 1-.538.538h-3.609l-.43 4.065a.3.3 0 0 1-.089.172.23.23 0 0 1-.172.069H850a.247.247 0 0 1-.269-.226l-.639-4.082h-3.4a.544.544 0 0 1-.538-.538 2.9 2.9 0 0 1 .66-1.863l.014-.017a6.6 6.6 0 0 0 1.479-4.166v-.032a1.34 1.34 0 0 0-.589-1.1 1.3 1.3 0 0 1-.168-.14 1.077 1.077 0 0 1 .757-1.834h5.385a1.073 1.073 0 0 1 .758 1.837 1.3 1.3 0 0 1-.169.143 1.34 1.34 0 0 0-.588 1.1v.029a6.58 6.58 0 0 0 1.472 4.156l.021.026a2.9 2.9 0 0 1 .66 1.863",
    "data-name": "\\u56FE\\u9489 (1)"
  }))));
};
export default SvgNewcsDashboardCrashanalysisIssuedetailTracedataOperateYesIcon;